import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/srv/projects/www.cultus-dresden.de/site/app/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/srv/projects/www.cultus-dresden.de/site/app/layouts/home.vue").then(m => m.default || m)),
  "site-default": defineAsyncComponent(() => import("/srv/projects/www.cultus-dresden.de/api/vendors/gsmaterials/app/layouts/site/default.vue").then(m => m.default || m))
}